document.documentElement.classList.remove('no-js');

const formatMoney = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: currency || 'EUR' }).format((cents || 0) / 100);

function initRandomCollectionProducts(root = document) {
  const grids = root.matches?.('[data-random-product-grid]') ? [root] : [...root.querySelectorAll('[data-random-product-grid]')];
  grids.forEach((grid) => {
    if (grid.dataset.randomized === 'true') return;
    const cards = [...grid.children].filter((child) => child.matches('.product-card'));
    if (!cards.length) return;

    for (let index = cards.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
    }

    const productLimit = Number.parseInt(grid.dataset.productLimit, 10) || 8;
    cards.forEach((card, index) => {
      card.hidden = index >= productLimit;
      grid.append(card);
    });
    grid.dataset.randomized = 'true';
  });
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach((element) => { element.textContent = count; element.hidden = count === 0; });
}

const shopifyCartUrl = (path) => `${window.Shopify?.routes?.root || '/'}${path}`;

function renderStickyCartSummaries(cart, root = document) {
  const bars = root.matches?.('[data-sticky-purchase-bar]') ? [root] : [...root.querySelectorAll('[data-sticky-purchase-bar]')];
  const count = Number(cart?.item_count || 0);
  const total = formatMoney(cart?.total_price || 0, cart?.currency);
  bars.forEach((sticky) => {
    sticky.querySelectorAll('[data-sticky-cart-summary]').forEach((summary) => {
      const template = count === 0 ? summary.dataset.emptyTemplate : count === 1 ? summary.dataset.oneTemplate : summary.dataset.otherTemplate;
      summary.textContent = String(template || '').replace('__count__', String(count)).replace('__total__', total);
    });
    const items = sticky.querySelector('[data-sticky-cart-items]');
    if (items) {
      const itemTemplate = items.dataset.itemTemplate || '';
      const lines = (cart?.items || []).map((item) => {
        const row = document.createElement('li');
        const name = document.createElement('span');
        const productName = item.product_title || item.product?.title || item.title || '';
        const variantName = item.variant_title || item.variant?.title || '';
        name.className = 'sticky-purchase__cart-item-name';
        name.textContent = productName && variantName && variantName !== 'Default Title' ? `${productName} · ${variantName}` : productName;
        const quantity = document.createElement('span');
        quantity.textContent = itemTemplate.replace('__quantity__', String(item.quantity || 0));
        const lineTotal = document.createElement('strong');
        const cents = item.final_line_price ?? item.line_price ?? (Number(item.final_price ?? item.price ?? 0) * Number(item.quantity || 0));
        lineTotal.textContent = formatMoney(cents, cart?.currency);
        row.append(name, quantity, lineTotal);
        return row;
      });
      items.replaceChildren(...lines);
      items.hidden = lines.length === 0;
    }
    const subtotal = sticky.querySelector('[data-sticky-cart-subtotal]');
    if (subtotal) subtotal.textContent = total;
  });
}

async function refreshStickyCartSummaries(root = document) {
  const response = await fetch(shopifyCartUrl('cart.js'), { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
  const cart = await response.json();
  updateCartCount(cart.item_count);
  renderStickyCartSummaries(cart, root);
  return cart;
}

function initProductGalleries() {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const items = [...gallery.querySelectorAll('[data-product-media]')];
    if (!items.length) return;
    const section = gallery.closest('[data-product-section]');
    let variants = [];
    try { variants = JSON.parse(section?.querySelector('[data-product-variants]')?.textContent || '[]'); } catch {}
    const variantMediaIds = new Set(variants.map((variant) => String(variant.featured_media?.id || '')).filter(Boolean));
    const mediaQuery = window.matchMedia('(max-width: 749px)');
    const status = gallery.querySelector('[data-product-gallery-status]');
    const controls = gallery.querySelector('[data-product-gallery-controls]');
    const lightbox = section?.querySelector('[data-product-gallery-lightbox]');
    const lightboxItems = [...(lightbox?.querySelectorAll('[data-product-lightbox-media]') || [])];
    const lightboxStatus = lightbox?.querySelector('[data-product-lightbox-status]');
    let currentItem = items.find((item) => item.classList.contains('is-active')) || items[0];
    let lightboxItem = null;
    let lightboxTrigger = null;

    const visibleItems = () => items.filter((item) => !item.hidden);
    const visibleLightboxItems = () => lightboxItems.filter((item) => {
      const media = items.find((galleryItem) => galleryItem.dataset.mediaId === item.dataset.mediaId);
      return media && !media.hidden;
    });

    const renderLightbox = () => {
      if (!lightbox) return;
      const visible = visibleLightboxItems();
      if (!visible.includes(lightboxItem)) lightboxItem = visible.find((item) => item.dataset.mediaId === currentItem?.dataset.mediaId) || visible[0] || null;
      lightboxItems.forEach((item) => {
        const isActive = item === lightboxItem;
        item.hidden = !isActive;
        item.classList.toggle('is-active', isActive);
      });
      const currentIndex = visible.indexOf(lightboxItem);
      if (lightboxStatus) lightboxStatus.textContent = lightboxStatus.dataset.statusTemplate.replace('{{ current }}', String(currentIndex + 1)).replace('{{ total }}', String(visible.length));
      lightbox.querySelectorAll('[data-product-lightbox-previous], [data-product-lightbox-next]').forEach((button) => { button.hidden = visible.length < 2; });
    };

    const render = () => {
      const visible = visibleItems();
      if (!visible.includes(currentItem)) currentItem = visible[0] || null;
      items.forEach((item, index) => {
        const isActive = item === currentItem;
        item.classList.toggle('is-active', isActive);
        item.classList.toggle('is-primary', isActive);
        if (mediaQuery.matches) item.setAttribute('aria-hidden', String(!isActive || item.hidden));
        else item.removeAttribute('aria-hidden');
      });
      if (controls) controls.hidden = visible.length < 2;
      const currentIndex = visible.indexOf(currentItem);
      if (status) status.textContent = status.dataset.statusTemplate.replace('{{ current }}', String(currentIndex + 1)).replace('{{ total }}', String(visible.length));
      renderLightbox();
    };

    const show = (item, scroll = false) => {
      if (!item || item.hidden) return;
      currentItem = item;
      render();
      if (scroll && !mediaQuery.matches) item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    const setVariant = (variant) => {
      const selectedMediaId = String(variant?.featured_media?.id || '');
      items.forEach((item) => {
        const isVariantSpecific = variantMediaIds.has(item.dataset.mediaId);
        item.hidden = isVariantSpecific && item.dataset.mediaId !== selectedMediaId;
      });
      currentItem = items.find((item) => item.dataset.mediaId === selectedMediaId && !item.hidden) || visibleItems()[0] || null;
      lightboxItem = null;
      render();
      return currentItem;
    };

    const openLightbox = (item, trigger) => {
      if (!lightbox || typeof lightbox.showModal !== 'function') return;
      lightboxItem = lightboxItems.find((lightboxMedia) => lightboxMedia.dataset.mediaId === item.dataset.mediaId) || null;
      if (!lightboxItem) return;
      lightboxTrigger = trigger;
      renderLightbox();
      lightbox.showModal();
      lightbox.querySelector('[data-product-lightbox-close]')?.focus();
    };

    gallery.showMedia = show;
    gallery.setVariant = setVariant;
    gallery.isMobileGallery = () => mediaQuery.matches;
    gallery.querySelector('[data-product-gallery-previous]')?.addEventListener('click', () => {
      const visible = visibleItems(); const currentIndex = visible.indexOf(currentItem); show(visible[(currentIndex - 1 + visible.length) % visible.length]);
    });
    gallery.querySelector('[data-product-gallery-next]')?.addEventListener('click', () => {
      const visible = visibleItems(); const currentIndex = visible.indexOf(currentItem); show(visible[(currentIndex + 1) % visible.length]);
    });
    gallery.querySelectorAll('[data-product-media-trigger]').forEach((trigger) => trigger.addEventListener('click', () => openLightbox(trigger.closest('[data-product-media]'), trigger)));
    lightbox?.querySelector('[data-product-lightbox-close]')?.addEventListener('click', () => lightbox.close());
    lightbox?.addEventListener('close', () => lightboxTrigger?.focus());
    lightbox?.querySelector('[data-product-lightbox-previous]')?.addEventListener('click', () => {
      const visible = visibleLightboxItems(); const index = visible.indexOf(lightboxItem); lightboxItem = visible[(index - 1 + visible.length) % visible.length]; currentItem = items.find((item) => item.dataset.mediaId === lightboxItem.dataset.mediaId) || currentItem; render();
    });
    lightbox?.querySelector('[data-product-lightbox-next]')?.addEventListener('click', () => {
      const visible = visibleLightboxItems(); const index = visible.indexOf(lightboxItem); lightboxItem = visible[(index + 1) % visible.length]; currentItem = items.find((item) => item.dataset.mediaId === lightboxItem.dataset.mediaId) || currentItem; render();
    });
    mediaQuery.addEventListener('change', render);
    const initialVariant = variants.find((variant) => String(variant.id) === section?.querySelector('[data-variant-id]')?.value);
    setVariant(initialVariant);
  });
}

async function refreshCartDrawer(open = false, added = false) {
  const sectionUrl = new URL(window.location.href);
  sectionUrl.searchParams.set('section_id', 'cart-drawer');
  const response = await fetch(sectionUrl, { headers: { Accept: 'text/html' } });
  if (!response.ok) throw new Error('Der Warenkorb konnte nicht geladen werden.');
  const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
  const replacement = documentFragment.querySelector('[data-cart-drawer]');
  const current = document.querySelector('[data-cart-drawer]');
  if (!replacement || !current) throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
  current.replaceWith(replacement);
  if (added) {
    const addedStatus = replacement.querySelector('[data-cart-added-status]');
    if (addedStatus) addedStatus.hidden = false;
  }
  const cart = await refreshStickyCartSummaries();
  if (open) openCartDrawer();
}

function openCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  drawer.hidden = false;
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('overflow-hidden');
  drawer.querySelector('[data-cart-drawer-close], input, button, a')?.focus();
}

function closeCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  drawer.hidden = true;
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('overflow-hidden');
}

function syncStickyQuantity(form) {
  const sticky = form?.querySelector('[data-sticky-purchase-bar]');
  if (!sticky) return;
  const quantity = Number(form.querySelector('[data-quantity-input]')?.value || 1);
  const quantityLabel = sticky.querySelector('[data-sticky-order-quantity]');
  const detailQuantity = sticky.querySelector('[data-sticky-detail-quantity]');
  if (quantityLabel) quantityLabel.textContent = quantityLabel.dataset.quantityTemplate.replace('__quantity__', String(quantity));
  if (detailQuantity) detailQuantity.textContent = detailQuantity.dataset.quantityTemplate.replace('__quantity__', String(quantity));
}

function syncStickyPurchase(form, variant) {
  const sticky = form?.querySelector('[data-sticky-purchase-bar]');
  if (!sticky) return;
  syncStickyQuantity(form);
  if (!variant) return;
  const variantLabel = sticky.querySelector('[data-sticky-variant-label]');
  const detailVariant = sticky.querySelector('[data-sticky-detail-variant]');
  const price = sticky.querySelector('[data-sticky-price]');
  const detailPrice = sticky.querySelector('[data-sticky-detail-price]');
  const savingsText = form.querySelector('[data-flag-bundle-savings]');
  const savings = savingsText && !savingsText.hidden ? savingsText.textContent.trim() : '';
  const stickySavings = sticky.querySelector('[data-sticky-savings]');
  const detailSavingsRow = sticky.querySelector('[data-sticky-detail-savings-row]');
  const detailSavings = sticky.querySelector('[data-sticky-detail-savings]');
  const image = variant.featured_media?.preview_image?.src || variant.featured_image?.src;
  const imageElement = sticky.querySelector('[data-sticky-product-image] img');
  const addButton = sticky.querySelector('[data-sticky-add-to-cart]');
  const checkoutButton = sticky.querySelector('[data-sticky-checkout]');
  const currency = form.querySelector('[data-variant-picker]')?.dataset.currency || 'EUR';

  if (variantLabel) variantLabel.textContent = variant.title;
  if (detailVariant) detailVariant.textContent = variant.title;
  if (price) price.textContent = formatMoney(variant.price, currency);
  if (detailPrice) detailPrice.textContent = formatMoney(variant.price, currency);
  if (stickySavings) { stickySavings.textContent = savings; stickySavings.hidden = !savings; }
  if (detailSavings) detailSavings.textContent = savings;
  if (detailSavingsRow) detailSavingsRow.hidden = !savings;
  if (image && imageElement) {
    try {
      const imageUrl = new URL(image, window.location.origin);
      imageUrl.searchParams.set('width', '96');
      imageElement.srcset = '';
      imageElement.src = imageUrl.toString();
    } catch {}
  }
  if (addButton) addButton.disabled = !variant.available;
  if (checkoutButton) checkoutButton.disabled = !variant.available;
}

function initStickyPurchaseBars(root = document) {
  const bars = root.matches?.('[data-sticky-purchase-bar]') ? [root] : [...root.querySelectorAll('[data-sticky-purchase-bar]')];
  bars.forEach((sticky) => {
    const form = sticky.closest('.product-form');
    const purchaseArea = form?.querySelector('[data-primary-purchase-area]');
    const variantPicker = form?.querySelector('[data-variant-picker]');
    if (!form || !purchaseArea || sticky.dataset.stickyInitialized) return;
    sticky.dataset.stickyInitialized = 'true';

    const setVisible = (visible) => { sticky.hidden = !visible; };
    const syncCurrentVariant = () => {
      const id = form.querySelector('[data-variant-id]')?.value;
      const variant = variantPicker?.variants?.find((item) => String(item.id) === String(id));
      if (variant) syncStickyPurchase(form, variant);
    };
    syncCurrentVariant();

    const summaryButton = sticky.querySelector('[data-sticky-summary]');
    const details = sticky.querySelector('[data-sticky-details]');
    const summaryAction = sticky.querySelector('[data-sticky-summary-action]');
    const setExpanded = (expanded) => {
      summaryButton?.setAttribute('aria-expanded', String(expanded));
      if (summaryAction && summaryButton) summaryAction.textContent = expanded ? summaryButton.dataset.closeLabel : summaryButton.dataset.openLabel;
      if (details) details.hidden = !expanded;
    };
    summaryButton?.addEventListener('click', () => setExpanded(summaryButton.getAttribute('aria-expanded') !== 'true'));
    sticky.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && summaryButton?.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        setExpanded(false);
        summaryButton.focus();
      }
    });
    sticky.querySelector('[data-sticky-add-to-cart]')?.addEventListener('click', () => {
      const addButton = form.querySelector('[data-add-to-cart]');
      if (addButton && !addButton.disabled) form.requestSubmit(addButton);
    });
    sticky.querySelector('[data-sticky-checkout]')?.addEventListener('click', () => {
      const addButton = form.querySelector('[data-add-to-cart]');
      if (!addButton || addButton.disabled) return;
      form.dataset.stickySubmitIntent = 'checkout';
      form.requestSubmit(addButton);
      window.setTimeout(() => {
        if (form.dataset.stickySubmitIntent === 'checkout') delete form.dataset.stickySubmitIntent;
      }, 0);
    });

    const updateVisibility = () => setVisible(purchaseArea.getBoundingClientRect().bottom < 0);
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  });
}

function calculateBundleSavings(variant, variants, quantityOptionIndex) {
  const optionIndex = Number(quantityOptionIndex);
  if (!variant || !Array.isArray(variant.options) || !Array.isArray(variants) || !Number.isInteger(optionIndex) || optionIndex < 0 || optionIndex >= variant.options.length) return null;
  const quantityMatch = String(variant.options[optionIndex] || '').match(/^\s*(\d+)/);
  const quantity = Number(quantityMatch?.[1]);
  if (!Number.isInteger(quantity) || quantity <= 1) return null;
  const referenceVariant = variants.find((candidate) => {
    if (!Array.isArray(candidate.options) || candidate.options.length !== variant.options.length) return false;
    const candidateQuantity = Number(String(candidate.options[optionIndex] || '').match(/^\s*(\d+)/)?.[1]);
    return candidateQuantity === 1 && candidate.options.every((option, index) => index === optionIndex || option === variant.options[index]);
  });
  if (!referenceVariant) return null;
  const referenceTotal = Number(referenceVariant.price) * quantity;
  const savings = referenceTotal - Number(variant.price);
  if (!Number.isFinite(referenceTotal) || !Number.isFinite(savings) || savings <= 0) return null;
  return { quantity, referenceTotal, savings, percent: (savings / referenceTotal) * 100 };
}

class VariantPicker extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
    this.rules = JSON.parse(this.querySelector('[data-quantity-rules]').textContent);
    this.currency = this.dataset.currency;
    this.inputs = [...this.querySelectorAll('[data-option-input]')];
    this.inputs.forEach((input) => input.addEventListener('change', () => {
      this.selectInput(input);
      this.update();
    }));
    this.update();
  }

  selectInput(selectedInput) {
    this.inputs.forEach((input) => {
      if (input.dataset.optionIndex === selectedInput.dataset.optionIndex) input.checked = input === selectedInput;
    });
  }

  selectedOptions() {
    return [...new Set(this.inputs.map((input) => input.dataset.optionIndex))]
      .sort((a, b) => Number(a) - Number(b))
      .map((optionIndex) => this.inputs.find((input) => input.dataset.optionIndex === optionIndex && input.checked)?.value);
  }

  syncSelectedLabels() {
    this.inputs.forEach((input) => {
      const label = input.nextElementSibling;
      if (!label?.matches('[data-option-label]')) return;
      label.classList.toggle('is-selected', input.checked);
    });
  }

  update() {
    const selected = this.selectedOptions();
    this.syncSelectedLabels();
    const variant = this.variants.find((item) => item.options.every((option, index) => option === selected[index]));
    const button = this.form.querySelector('[data-add-to-cart]');
    const buttonText = this.form.querySelector('[data-add-to-cart-text]');
    const stickyButtons = this.form.querySelectorAll('[data-sticky-add-to-cart], [data-sticky-checkout]');
    const error = this.form.querySelector('[data-product-error]');
    const id = this.form.querySelector('[data-variant-id]');
    const price = this.closest('[data-product-section]').querySelector('[data-product-price-current]');
    const compare = this.closest('[data-product-section]').querySelector('[data-product-price-compare]');
    const bundlePricing = this.form.querySelector('[data-flag-bundle-pricing]');
    const quantity = this.form.querySelector('[data-quantity-input]');
    this.inputs.forEach((input) => {
      const partial = selected.map((value, index) => index === Number(input.dataset.optionIndex) ? input.value : value);
      const viable = this.variants.some((item) => item.available && item.options.every((option, index) => !partial[index] || option === partial[index]));
      input.disabled = !viable && !input.checked;
      input.nextElementSibling?.classList.toggle('is-unavailable', input.disabled);
    });
    if (!variant) { button.disabled = true; stickyButtons.forEach((stickyButton) => { stickyButton.disabled = true; }); error.textContent = button.dataset.unavailableText || 'Diese Kombination ist nicht verfügbar.'; error.hidden = false; return; }
    id.value = variant.id;
    id.dispatchEvent(new Event('change', { bubbles: true }));
    button.disabled = !variant.available;
    stickyButtons.forEach((stickyButton) => { stickyButton.disabled = !variant.available; });
    buttonText.textContent = variant.available ? button.dataset.availableText : button.dataset.soldOutText;
    error.hidden = true;
    price.textContent = formatMoney(variant.price, this.currency);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) { compare.textContent = formatMoney(variant.compare_at_price, this.currency); compare.hidden = false; } else { compare.hidden = true; }
    if (bundlePricing) {
      const comparison = bundlePricing.querySelector('[data-flag-bundle-comparison]');
      const reference = bundlePricing.querySelector('[data-flag-bundle-reference]');
      const savingsRow = bundlePricing.querySelector('[data-flag-bundle-savings]');
      const savingsMessage = bundlePricing.querySelector('[data-flag-bundle-savings-message]');
      const savings = calculateBundleSavings(variant, this.variants, this.dataset.bundleOptionIndex);
      if (savings) {
        reference.textContent = formatMoney(savings.referenceTotal, this.currency);
        savingsMessage.textContent = savingsMessage.dataset.savingsTemplate
          .replace('__amount__', formatMoney(savings.savings, this.currency))
          .replace('__percent__', new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(savings.percent));
        comparison.hidden = false;
        savingsRow.hidden = false;
      } else {
        comparison.hidden = true;
        savingsRow.hidden = true;
      }
    }
    const rule = this.rules[String(variant.id)] || { min: 1, max: 0, increment: 1 };
    const previousQuantity = Number(quantity.value);
    const quantityValues = Array.from({ length: 10 }, (_, index) => rule.min + (index * rule.increment))
      .filter((value) => !rule.max || value <= rule.max);
    quantity.replaceChildren(...quantityValues.map((value) => {
      const option = document.createElement('option');
      option.value = String(value);
      option.textContent = quantity.dataset.quantityOptionTemplate.replace('__quantity__', String(value));
      return option;
    }));
    quantity.value = quantityValues.includes(previousQuantity) ? String(previousQuantity) : String(quantityValues[0] || rule.min);
    syncStickyPurchase(this.form, variant);
    const gallery = this.closest('[data-product-section]').querySelector('[data-product-gallery]');
    gallery?.setVariant?.(variant);
    const media = variant.featured_media?.id ? gallery?.querySelector(`[data-media-id="${variant.featured_media.id}"]`) : null;
    if (media && !gallery?.isMobileGallery?.()) media.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    const url = new URL(this.dataset.productUrl, window.location.origin); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
  }
}
customElements.define('variant-picker', VariantPicker);

function initPredictiveSearch() {
  const dialog = document.querySelector('[data-search-dialog]');
  const input = document.querySelector('[data-predictive-search-input]');
  const results = document.querySelector('[data-predictive-search-results]');
  const status = document.querySelector('#PredictiveSearchStatus');
  if (!dialog || !input || !results) return;
  let controller; let timeout;
  const renderResults = (data) => {
    const groups = data.resources?.results || {};
    const items = [...(groups.products || []), ...(groups.collections || []), ...(groups.pages || [])];
    results.innerHTML = items.length ? `<ul class="predictive-results">${items.map((item) => `<li><a href="${item.url}">${item.image ? `<img src="${item.image}" alt="">` : ''}<span>${item.title}</span></a></li>`).join('')}</ul>` : '<p class="muted">Keine passenden Ergebnisse.</p>';
    input.setAttribute('aria-expanded', String(items.length > 0));
    status.textContent = items.length ? `${items.length} Vorschläge verfügbar.` : 'Keine Vorschläge verfügbar.';
  };
  input.addEventListener('input', () => {
    window.clearTimeout(timeout);
    const query = input.value.trim();
    if (query.length < 2) { results.replaceChildren(); input.setAttribute('aria-expanded', 'false'); return; }
    timeout = window.setTimeout(async () => {
      controller?.abort(); controller = new AbortController();
      try {
        const params = new URLSearchParams({ q: query, 'resources[type]': 'product,collection,page', 'resources[limit]': '6' });
        const response = await fetch(`/search/suggest.json?${params}`, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(); renderResults(await response.json());
      } catch (error) { if (error.name !== 'AbortError') status.textContent = 'Vorschläge konnten nicht geladen werden.'; }
    }, 200);
  });
  document.querySelectorAll('[data-search-toggle]').forEach((button) => button.addEventListener('click', () => { dialog.showModal(); input.focus(); }));
  dialog.querySelector('[data-search-close]')?.addEventListener('click', () => dialog.close());
}


const colorSwitchScrollStorageKey = 'heimat-ehre:product-color-switch-scroll';

function preserveColorSwitchScroll(event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('[data-product-color-link]');
  if (!link) return;
  try {
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin || destination.pathname === window.location.pathname) return;
    const switcher = link.closest('#product-color-switcher');
    window.sessionStorage.setItem(colorSwitchScrollStorageKey, JSON.stringify({ path: destination.pathname, position: window.scrollY, switcherOffset: switcher?.getBoundingClientRect().top }));
  } catch {}
}

function restoreColorSwitchScroll() {
  try {
    const stored = window.sessionStorage.getItem(colorSwitchScrollStorageKey);
    if (!stored) return;
    const state = JSON.parse(stored);
    if (state.path !== window.location.pathname || !Number.isFinite(state.position)) return;
    window.sessionStorage.removeItem(colorSwitchScrollStorageKey);
    const restore = () => window.requestAnimationFrame(() => {
      const switcher = document.querySelector('#product-color-switcher');
      const position = Number.isFinite(state.switcherOffset) && switcher
        ? window.scrollY + switcher.getBoundingClientRect().top - state.switcherOffset
        : state.position;
      window.scrollTo({ top: position, left: 0, behavior: 'auto' });
    });
    if (document.readyState === 'complete') restore();
    else window.addEventListener('load', restore, { once: true });
  } catch {}
}

document.addEventListener('click', async (event) => {
  preserveColorSwitchScroll(event);
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) { const panel = document.querySelector('[data-mobile-menu]'); const isOpen = panel && !panel.hidden; if (panel) panel.hidden = isOpen; toggle.setAttribute('aria-expanded', String(!isOpen)); }
  if (event.target.closest('[data-cart-drawer-close]')) closeCartDrawer();
  const remove = event.target.closest('[data-cart-remove]');
  if (remove) { const item = remove.closest('[data-cart-item]'); try { await fetch(shopifyCartUrl('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.dataset.lineKey, quantity: 0 }) }); await refreshCartDrawer(true); } catch { const error = document.querySelector('[data-cart-error]'); if (error) { error.textContent = 'Der Artikel konnte nicht entfernt werden.'; error.hidden = false; } } }
});

document.addEventListener('change', async (event) => {
  if (event.target.matches('[data-auto-submit]')) event.target.form?.requestSubmit();
  if (event.target.matches('[data-quantity-input]')) {
    const form = event.target.closest('.product-form');
    const variantPicker = form?.querySelector('[data-variant-picker]');
    const variant = variantPicker?.variants?.find((item) => String(item.id) === form.querySelector('[data-variant-id]')?.value);
    if (variant) syncStickyPurchase(form, variant);
    else syncStickyQuantity(form);
  }
  if (event.target.matches('[data-cart-quantity]')) { const item = event.target.closest('[data-cart-item]'); try { const response = await fetch(shopifyCartUrl('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.dataset.lineKey, quantity: Number(event.target.value) }) }); if (!response.ok) throw new Error(); await refreshCartDrawer(true); } catch { const error = document.querySelector('[data-cart-error]'); if (error) { error.textContent = 'Die Menge konnte nicht aktualisiert werden.'; error.hidden = false; } } }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.product-form');
  if (!form || !event.submitter?.matches('[data-add-to-cart]') || !window.fetch) return;
  const checkoutIntent = form.dataset.stickySubmitIntent === 'checkout';
  delete form.dataset.stickySubmitIntent;
  event.preventDefault();
  const error = form.querySelector('[data-product-error]');
  const button = form.querySelector('[data-add-to-cart]');
  const sticky = form.querySelector('[data-sticky-purchase-bar]');
  const stickyButton = sticky?.querySelector('[data-sticky-add-to-cart]');
  const stickyCheckoutButton = sticky?.querySelector('[data-sticky-checkout]');
  const added = form.querySelector('[data-product-added]');
  const stickyActions = sticky?.querySelector('[data-sticky-actions]');
  const stickySuccess = sticky?.querySelector('[data-sticky-success]');
  const stickyError = sticky?.querySelector('[data-sticky-error]');
  error.hidden = true;
  if (added) added.hidden = true;
  if (stickySuccess) stickySuccess.hidden = true;
  if (stickyError) stickyError.hidden = true;
  button.disabled = true;
  if (stickyButton) stickyButton.disabled = true;
  if (stickyCheckoutButton) stickyCheckoutButton.disabled = true;
  try {
    const response = await fetch(shopifyCartUrl('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    const result = await response.json().catch(() => null);
    if (!response.ok) throw new Error(result?.description || result?.message || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.');
    if (!result || !result.id || !result.quantity) throw new Error('Shopify hat keine bestätigte Warenkorbposition zurückgegeben.');
    if (checkoutIntent) {
      try { await refreshStickyCartSummaries(); } catch {}
      window.location.assign(shopifyCartUrl('checkout'));
      return;
    }
    if (added) added.hidden = false;
    if (stickySuccess) {
      stickySuccess.hidden = false;
      if (stickyActions) stickyActions.hidden = true;
      window.setTimeout(() => {
        stickySuccess.hidden = true;
        if (stickyActions) stickyActions.hidden = false;
      }, 4000);
    }
    try { await refreshCartDrawer(true, true); } catch {}
  } catch (exception) {
    error.textContent = exception.message || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.';
    error.hidden = false;
    if (stickyError) { stickyError.textContent = error.textContent; stickyError.hidden = false; }
  } finally {
    const variants = form.querySelector('[data-variant-picker]')?.variants;
    const currentVariant = variants?.find((item) => String(item.id) === form.querySelector('[data-variant-id]')?.value);
    const available = currentVariant ? currentVariant.available : button.dataset.defaultAvailable === 'true';
    button.disabled = !available;
    if (stickyButton) stickyButton.disabled = !available;
    if (stickyCheckoutButton) stickyCheckoutButton.disabled = !available;
  }
});

document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { closeCartDrawer(); const panel = document.querySelector('[data-mobile-menu]'); if (panel && !panel.hidden) panel.hidden = true; } });
const communityVideoObservers = new WeakMap();

function initCommunityShopifyVideos(root = document) {
  const videos = root.matches?.('[data-community-shopify-video]') ? [root] : [...root.querySelectorAll('[data-community-shopify-video]')];
  videos.forEach((video) => {
    if (video.dataset.communityVideoInitialized) return;
    video.dataset.communityVideoInitialized = 'true';
    if (typeof IntersectionObserver !== 'function') return;

    const status = video.closest('[data-community-video]')?.querySelector('[data-community-video-status]');
    let loaded = false;
    let inViewport = false;
    const attachSources = () => {
      if (loaded) return;
      const sources = [...video.querySelectorAll('source[data-lazy-src]')];
      if (!sources.length) return;
      loaded = true;
      const poster = video.dataset.lazyPoster;
      if (poster) {
        video.poster = poster;
        delete video.dataset.lazyPoster;
      }
      sources.forEach((source) => {
        source.src = source.dataset.lazySrc;
        delete source.dataset.lazySrc;
      });
      video.querySelectorAll('img[data-lazy-src]').forEach((image) => {
        image.src = image.dataset.lazySrc;
        delete image.dataset.lazySrc;
      });
      video.querySelectorAll('img[data-lazy-srcset]').forEach((image) => {
        image.srcset = image.dataset.lazySrcset;
        delete image.dataset.lazySrcset;
      });
      video.preload = 'auto';
      video.load();
    };
    const playWhenVisible = () => {
      if (!loaded || !inViewport || video.ended || document.visibilityState === 'hidden') return;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('autoplay', 'autoplay');
      const playback = video.play();
      if (playback && typeof playback.catch === 'function') {
        playback.catch((error) => {
          if (error.name === 'AbortError') return;
          video.removeAttribute('autoplay');
          if (status) status.textContent = video.dataset.autoplayBlockedText || '';
        });
      }
    };
    video.addEventListener('canplay', playWhenVisible);
    video.addEventListener('error', () => {
      if (status) status.textContent = video.dataset.videoLoadFailed || '';
    }, { once: true });

    const loadObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        attachSources();
        if (loaded) loadObserver.disconnect();
      }
    }, { rootMargin: '280px 0px' });
    const viewportObserver = new IntersectionObserver((entries) => {
      const entry = entries[entries.length - 1];
      inViewport = Boolean(entry?.isIntersecting && entry.intersectionRatio >= 0.2);
      if (inViewport) {
        attachSources();
        playWhenVisible();
      }
    }, { threshold: [0, 0.2] });
    communityVideoObservers.set(video, { loadObserver, viewportObserver });
    loadObserver.observe(video);
    viewportObserver.observe(video);
  });
}

function disposeCommunityShopifyVideos(root) {
  const videos = root.matches?.('[data-community-shopify-video]') ? [root] : [...root.querySelectorAll('[data-community-shopify-video]')];
  videos.forEach((video) => {
    const observers = communityVideoObservers.get(video);
    observers?.loadObserver.disconnect();
    observers?.viewportObserver.disconnect();
    video.pause();
    video.removeAttribute('autoplay');
    communityVideoObservers.delete(video);
    delete video.dataset.communityVideoInitialized;
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCommunityShopifyVideos(), { once: true });
else initCommunityShopifyVideos();
document.addEventListener('shopify:section:load', (event) => initCommunityShopifyVideos(event.target));
document.addEventListener('shopify:section:unload', (event) => disposeCommunityShopifyVideos(event.target));

let instagramEmbedScriptPromise = null;

function loadInstagramEmbedScript() {
  if (window.instgrm?.Embeds?.process) return Promise.resolve();
  if (instagramEmbedScriptPromise) return instagramEmbedScriptPromise;
  instagramEmbedScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    script.dataset.instagramEmbedScript = '';
    script.addEventListener('load', () => window.instgrm?.Embeds?.process ? resolve() : reject(new Error('Instagram embed API unavailable.')), { once: true });
    script.addEventListener('error', () => reject(new Error('Instagram embed script failed to load.')), { once: true });
    document.head.append(script);
  }).catch((error) => {
    instagramEmbedScriptPromise = null;
    throw error;
  });
  return instagramEmbedScriptPromise;
}

function canonicalInstagramReelUrl(value) {
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || !['instagram.com', 'www.instagram.com'].includes(url.hostname.toLowerCase())) return null;
    if (!/^\/reel\/[\w-]+\/?$/.test(url.pathname)) return null;
    return `${url.origin}${url.pathname.endsWith('/') ? url.pathname : `${url.pathname}/`}`;
  } catch {
    return null;
  }
}

function initInstagramReels(root = document) {
  const containers = root.matches?.('[data-instagram-reel]') ? [root] : [...root.querySelectorAll('[data-instagram-reel]')];
  containers.forEach((container) => {
    const button = container.querySelector('[data-instagram-reel-load]');
    const embed = container.querySelector('[data-instagram-reel-embed]');
    const status = container.querySelector('[data-instagram-reel-status]');
    if (!button || !embed || button.dataset.instagramInitialized) return;
    button.dataset.instagramInitialized = 'true';
    button.addEventListener('click', async () => {
      const permalink = canonicalInstagramReelUrl(container.dataset.permalink || '');
      if (!permalink) {
        if (status) status.textContent = container.dataset.failedText || '';
        return;
      }

      const quote = document.createElement('blockquote');
      quote.className = 'instagram-media';
      quote.setAttribute('data-instgrm-permalink', permalink);
      quote.setAttribute('data-instgrm-version', '14');
      const fallbackLink = document.createElement('a');
      fallbackLink.href = permalink;
      fallbackLink.target = '_blank';
      fallbackLink.rel = 'noopener noreferrer';
      fallbackLink.textContent = container.dataset.openLinkText || 'Instagram';
      quote.append(fallbackLink);
      embed.replaceChildren(quote);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      embed.hidden = false;
      if (status) status.textContent = container.dataset.loadingText || '';

      let observer;
      let timeoutId;
      const focusFrameIfReady = () => {
        const frame = embed.querySelector('iframe');
        if (!frame) return false;
        frame.title = container.dataset.frameTitle || 'Instagram Reel';
        frame.tabIndex = 0;
        button.hidden = true;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        observer?.disconnect();
        window.clearTimeout(timeoutId);
        if (status) status.textContent = '';
        frame.focus();
        return true;
      };
      observer = new MutationObserver(focusFrameIfReady);
      observer.observe(embed, { childList: true, subtree: true });
      timeoutId = window.setTimeout(() => {
        observer.disconnect();
        if (!embed.querySelector('iframe')) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (status) status.textContent = container.dataset.failedText || '';
        }
      }, 10000);

      try {
        await loadInstagramEmbedScript();
        window.instgrm.Embeds.process();
        focusFrameIfReady();
      } catch {
        observer.disconnect();
        window.clearTimeout(timeoutId);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (status) status.textContent = container.dataset.failedText || '';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initInstagramReels());
document.addEventListener('shopify:section:load', (event) => initInstagramReels(event.target));
document.addEventListener('DOMContentLoaded', () => { restoreColorSwitchScroll(); initRandomCollectionProducts(); initPredictiveSearch(); initProductGalleries(); initStickyPurchaseBars(); refreshStickyCartSummaries().catch(() => {}); document.querySelectorAll('[data-product-recommendations-url]').forEach(async (container) => { try { const response = await fetch(container.dataset.productRecommendationsUrl); if (response.ok) { const fragment = new DOMParser().parseFromString(await response.text(), 'text/html'); const section = fragment.querySelector('[data-product-recommendations]'); if (section?.children.length) container.replaceWith(section); else container.remove(); } } catch { container.remove(); } }); });
window.addEventListener('focus', () => { if (document.querySelector('[data-sticky-purchase-bar]')) refreshStickyCartSummaries().catch(() => {}); });
document.addEventListener('shopify:section:load', (event) => { initRandomCollectionProducts(event.target); initStickyPurchaseBars(event.target); refreshStickyCartSummaries(event.target).catch(() => {}); });
